var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.833 5.504V2.588c0-.694 0-1.04-.146-1.253a.83.83 0 0 0-.547-.35c-.255-.044-.57.101-1.199.392L2.55 4.789c-.561.259-.842.388-1.047.59-.182.177-.32.393-.406.633C1 6.282 1 6.592 1 7.21v4.127m11.25-.417h.008M1 8.17v5.5c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182h9.666c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757v-5.5c0-.933 0-1.4-.182-1.756a1.67 1.67 0 0 0-.728-.729c-.357-.181-.823-.181-1.757-.181H3.667c-.934 0-1.4 0-1.757.181-.314.16-.569.415-.728.729C1 6.77 1 7.237 1 8.17m11.667 2.75a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0"
  })));
};
export default SvgWallet;